import React from "react";
import ViewOrderDetails from "./ViewOrderDetails";
import { useParams, useLocation } from "react-router";

function PurchaseOrderViewWrapper() {
  const { orderNumber }: any = useParams();
  const location = useLocation();
  const locationState = location.state as any;
  
  // If we came from PurchaseOrdersDrawer, navigate back to dashboard with drawer state
  const previousPath = locationState?.fromPurchaseOrdersDrawer
    ? "/dashboard"
    : locationState?.previousPath || "/view-purchase-order";
  
  const previousState = locationState?.previousState;
  const extraFromState = locationState?.extra || {};
  const extra = {
    hideAside: true,
    reduceTableWidth: 130,
    ...extraFromState,
    ...(previousState ? { previousState } : {}),
  };

  return (
    <ViewOrderDetails
      orderNumber={orderNumber}
      previousPath={previousPath}
      extra={extra}
    />
  );
}

export default PurchaseOrderViewWrapper;
